import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import type { SwiperOptions } from 'swiper/types/swiper-options';
import type { Swiper } from 'swiper/types';
import { swiperDefaultConfig } from './swiper.configuration';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'opac-swiper',
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.scss'],
})
export class SwiperComponent implements AfterViewInit, OnInit {
  get swiperContainer() {
    return this.swiper;
  }

  hasNavigation = true;
  resolvedConfiguration: SwiperOptions;

  @HostBinding('class.gradient') @Input() gradient = true;
  @Input() configuration: SwiperOptions;
  @Output() slideChange = new EventEmitter<Swiper>();

  @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;

  constructor(private readonly elementRef: ElementRef) {}

  ngOnInit() {
    this.resolvedConfiguration = {
      ...swiperDefaultConfig,
      ...this.configuration,
      navigation: {
        enabled: true,
        nextEl: this.elementRef.nativeElement.querySelector('.next-button'),
        prevEl: this.elementRef.nativeElement.querySelector('.previous-button'),
        ...this.configuration.navigation,
      },
    };

    if ('navigation' in this.resolvedConfiguration) {
      this.hasNavigation = this.resolvedConfiguration.navigation && this.resolvedConfiguration.navigation.enabled;
    }
  }

  ngAfterViewInit() {
    Object.assign(this.swiper.nativeElement, this.resolvedConfiguration);
    this.swiper.nativeElement.initialize();
  }

  handleBreakpointChange(event: CustomEvent<[Swiper, SwiperOptions]>) {
    const breakpointConfig = event.detail[1];

    if ('navigation' in breakpointConfig) {
      this.hasNavigation = breakpointConfig.navigation && breakpointConfig.navigation.enabled;
    }
  }

  handleSlideChange(event: CustomEvent<Swiper[]>) {
    this.slideChange.emit(event.detail[0]);
  }
}
